var connectorConfig = {
	
}

export { connectorConfig }